export const servicePortalUrl = "https://my-international-sana.itsaaz.com/home";
export const panelUrl = "https://panel.hamrahehushmand.com/";

export const mainNavigation = [
  { href: "/", label: "خانه" },
  { href: "/services", label: "خدمات" },
  { href: "/blog", label: "بلاگ" },
  { href: "/about", label: "درباره ما" },
  { href: "/contact", label: "تماس با ما" },
  { href: "/faq", label: "سوالات متداول" },
] as const;

export interface ServiceItem {
  title: string;
  description: string;
  icon: string;
  slug: string;
}

export interface HomeServiceItem extends ServiceItem {
  kicker: string;
  description2: string;
}

export const homeServices: HomeServiceItem[] = [
  {
    title: "ثبت‌نام و احراز هویت ثنا",
    kicker: "برای مشاهده توضیحات کلیک کنید",
    description: "ثبت‌نام و فعال‌سازی حساب ثنا برای دسترسی به خدمات قضایی آنلاین.",
    description2: "برای دریافت ابلاغیه‌ها و انجام امور قضایی بدون مراجعه حضوری.",
    icon: "fingerprint",
    slug: "sana-registration",
  },
  {
    title: "ثبت درخواست گواهی عدم سوءپیشینه",
    kicker: "برای مشاهده توضیحات کلیک کنید",
    description: "ثبت درخواست گواهی عدم سوءپیشینه به‌صورت آنلاین و غیرحضوری.",
    description2: "مناسب برای ارائه به سفارت، محل کار، دانشگاه و سایر مراجع رسمی.",
    icon: "certificate",
    slug: "criminal-record",
  },
  {
    title: "درخواست مشاوره قضایی آنلاین با وکیل دادگستری",
    kicker: "برای مشاهده توضیحات کلیک کنید",
    description: "دریافت مشاوره تخصصی از وکیل دادگستری درباره موضوع و مشکل حقوقی شما.",
    description2: "برای شناخت حقوق، بررسی راهکارها و تصمیم‌گیری بهتر قبل از اقدام قانونی.",
    icon: "scale",
    slug: "legal-consultation",
  },
  {
    title: "دسترسی به ثنا و ثبت امضای الکترونیک قضایی",
    kicker: "برای مشاهده توضیحات کلیک کنید",
    description: "فعال‌سازی و استفاده از امکانات ثنا و امضای الکترونیک برای امور قضایی.",
    description2: "راهکاری ساده برای انجام و تأیید برخی فرآیندهای قضایی به‌صورت آنلاین.",
    icon: "signature",
    slug: "electronic-signature",
  },
  {
    title: "ترجمه رسمی با تأییدات وزارت امور خارجه و دادگستری",
    kicker: "برای مشاهده توضیحات کلیک کنید",
    description: "ترجمه رسمی مدارک همراه با دریافت تأییدات لازم از دادگستری و وزارت امور خارجه.",
    description2: "مناسب برای سفارت، مهاجرت، تحصیل و استفاده رسمی از مدارک در خارج از کشور.",
    icon: "file-text",
    slug: "official-translation",
  },
  {
    title: "مشاهده و ارسال ابلاغیه‌های قضایی",
    kicker: "برای مشاهده توضیحات کلیک کنید",
    description: "مشاهده ابلاغیه‌های قضایی و اطلاع از آخرین اطلاع‌رسانی‌های مربوط به پرونده‌ها.",
    description2: "امکان دریافت و ارسال ابلاغیه‌ها بدون نیاز به مراجعه حضوری.",
    icon: "file-check",
    slug: "electronic-notices",
  },
  {
    title: "پرداخت قبض قوه قضاییه و دولتی",
    kicker: "برای مشاهده توضیحات کلیک کنید",
    description: "پرداخت آنلاین قبض‌ها و هزینه‌های مربوط به خدمات قضایی و دولتی.",
    description2: "سریع و آسان، بدون نیاز به مراجعه حضوری برای پرداخت.",
    icon: "wallet",
    slug: "judicial-payments",
  },
];

export const services: ServiceItem[] = [
  {
    title: "ثبت‌نام و احراز هویت ثنا",
    description: "ایجاد پرونده الکترونیک شما در سامانه ثنا",
    icon: "fingerprint",
    slug: "sana-registration",
  },
  {
    title: "گواهی عدم سوءپیشینه",
    description: "ثبت درخواست و دریافت آنلاین گواهی",
    icon: "certificate",
    slug: "criminal-record",
  },
  {
    title: "مشاهده ابلاغیه‌های الکترونیکی",
    description: "مشاهده امن ابلاغیه‌ها و ارسال مستندات مرتبط با پرونده",
    icon: "file-check",
    slug: "electronic-notices",
  },
  {
    title: "امضا و گواهی الکترونیک",
    description: "دسترسی و صدور گواهی‌های رسمی ثنا",
    icon: "signature",
    slug: "electronic-signature",
  },
  {
    title: "مشاوره حقوقی آنلاین",
    description: "ارتباط مستقیم با وکیل پایه‌یک دادگستری",
    icon: "scale",
    slug: "legal-consultation",
  },
  {
    title: "ترجمه رسمی مدارک",
    description: "ترجمه و تایید اسناد برای مراجع بین‌المللی",
    icon: "file-text",
    slug: "official-translation",
  },
  {
    title: "پرداخت هزینه‌های قضایی",
    description: "پرداخت آنلاین با کارت‌های بین‌المللی",
    icon: "wallet",
    slug: "judicial-payments",
  },
  {
    title: "پیگیری لحظه‌ای پرونده",
    description: "اطلاع‌رسانی فوری وضعیت دادگاه",
    icon: "activity",
    slug: "case-tracking",
  },
  {
    title: "جلسات قضایی آنلاین",
    description: "هماهنگی حضور آنلاین در جلسه دادگاه",
    icon: "phone-call",
    slug: "online-hearings",
  },
  {
    title: "استعلام وضعیت وکلا",
    description: "بررسی وضعیت و اعتبار حرفه‌ای وکیل",
    icon: "badge-check",
    slug: "lawyer-status-inquiry",
  },
  {
    title: "استعلام سوابق محکومیت‌های مالی",
    description: "دریافت اطلاعات قابل استعلام برای تصمیم‌گیری مطمئن‌تر",
    icon: "landmark",
    slug: "financial-conviction-inquiry",
  },
  {
    title: "استعلام سابقه چک برگشتی",
    description: "بررسی سابقه قابل استعلام دعاوی مرتبط با چک",
    icon: "receipt",
    slug: "bounced-cheque-inquiry",
  },
  {
    title: "صدور گواهی‌ها و استشهادیه‌های الکترونیکی",
    description: "تنظیم و ثبت استشهادیه به‌صورت الکترونیکی",
    icon: "check-square",
    slug: "electronic-certificates",
  },
];

export interface SanaFeature {
  title: string;
  description: string;
  icon: string;
}

export const sanaFeatures: SanaFeature[] = [
  {
    title: "ارائه پیوسته خدمات سامانه ثنا",
    description: "ارائه آنلاین از طریق درگاه بین‌المللی بدون وقفه",
    icon: "activity",
  },
  {
    title: "احراز هویت هوشمند",
    description: "احراز هویت بیومتریک متکی بر آخرین فناوری‌ها",
    icon: "fingerprint",
  },
  {
    title: "دسترسی کامل با کد ثنا",
    description: "دسترسی به کلیه اطلاعیه‌ها پس از صدور کد",
    icon: "key",
  },
];

export interface BenefitItem {
  label: string;
  description: string;
  icon: string;
}

export const benefitHighlight: BenefitItem = {
  label: "دسترسی آنلاین از هر نقطه جهان",
  description: "۲۴/۷",
  icon: "clock",
};

export const benefits: BenefitItem[] = [
  {
    label: "دسترسی برابر",
    description: "دسترسی عادلانه مقیمان خارج از کشور به خدمات قوه قضائیه",
    icon: "users",
  },
  {
    label: "هزینه کمتر",
    description: "کاهش چشمگیر هزینه‌های دسترسی به خدمات اداری و قضایی",
    icon: "wallet",
  },
  {
    label: "کاملاً غیرحضوری",
    description: "بدون نیاز به مراجعه حضوری به سفارتخانه‌ها یا کنسولگری‌ها",
    icon: "smartphone",
  },
  {
    label: "فرآیند یکپارچه",
    description: "صرفه‌جویی زمانی با سیستم خدمات الکترونیک یکپارچه",
    icon: "layers",
  },
  {
    label: "بدون سیم‌کارت ایران",
    description: "عدم نیاز به سیم‌کارت داخل کشور برای دریافت خدمات",
    icon: "phone",
  },
  {
    label: "پرداخت جهانی",
    description: "پرداخت هزینه‌ها با کارت‌های اعتباری بین‌المللی",
    icon: "credit",
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export interface FaqGroup {
  id: string;
  label: string;
  items: FaqItem[];
}

export const generalFaqHome: FaqGroup = {
  id: "general",
  label: "سوالات عمومی",
  items: [
    {
      question: "سامانه ثنا چیست؟",
      answer:
        "سامانه ثنا در سال ۱۳۹۵ برای ابلاغ اوراق قضایی، ارسال انواع اظهارنامه و ثبت دادخواست ارائه شد. از این تاریخ به بعد هیچ ابلاغیه‌ای به‌صورت کاغذی برای افراد ارسال نمی‌شود. تا قبل از سال ۱۳۹۵ وقتی برای شخصی دعوی در دادگاه مطرح می‌شد، ابلاغیه‌ای توسط ماموران ابلاغ به آدرس فرد خوانده در پرونده ارسال می‌شد. در این بین مشکلات زیادی پیش می‌آمد؛ برای مثال، ماموران ابلاغ، ابلاغیه را به آدرس فرد خوانده می‌بردند و ممکن بود فرد در منزل حضور نداشته باشد یا از گرفتن ابلاغیه امتناع کند. برای جلوگیری از پیش آمدن مشکلات این‌چنینی، ابلاغیه‌ها به‌صورت الکترونیکی برای مردم پیامک می‌شود. به‌صورت کلی هدف از این سامانه جلوگیری از اتلاف وقت برای افرادی است که امور قضایی دارند و پیشگیری از به وجود آمدن مشکلات احتمالی در روند ابلاغیه‌های قضایی است.",
    },
    {
      question: "سامانه خدمات الکترونیک قضایی ایرانیان خارج از کشور",
      answer:
        "کلیه ایرانیان خارج از کشور از طریق این سامانه، بدون نیاز به شماره همراه داخل کشور و نیز با امکان پرداخت هزینه به‌صورت ارزی با کارت‌های معتبر بین‌المللی همچون ویزا کارت و مسترکارت، خدمت ثنا را دریافت می‌کنند و به کلیه سرویس‌های الکترونیک قوه قضاییه به‌صورت ۲۴ ساعته دسترسی دارند.",
    },
    {
      question: "مشاهده ابلاغیه الکترونیکی ثنا",
      answer:
        "اولین کاربردی که این سامانه می‌تواند برای شما داشته باشد و بسیار هم می‌تواند به شما کمک کند، این است که با استفاده از این سامانه می‌توانید تمامی ابلاغیه‌های الکترونیکی خود را مشاهده کنید. دیگر نیاز نیست این ابلاغیه‌ها به‌صورت نامه برای شما ارسال شوند و مشاهده آن‌ها نیز زمان‌بر نخواهد بود.",
    },
    {
      question: "پیگیری پرونده‌های قضایی",
      answer:
        "یکی دیگر از کاربردهای این سامانه این است که می‌توانید به‌صورت الکترونیکی تمامی پرونده‌های قضایی خود را پیگیری و کنترل کنید. پیگیری پرونده‌های قضایی برای افراد زیادی دغدغه بوده است و همین دغدغه باعث شد این سامانه ایجاد شود تا بتوانید به‌صورت آنلاین تمامی پرونده‌های خود را مشاهده و به‌خوبی مدیریت کنید. پس اگر پرونده قضایی دارید، به سامانه ثنا نیاز دارید و باید در این سامانه ثبت‌نام کرده باشید تا بتوانید پرونده‌های خود را بهتر مدیریت کنید. فعال شدن دریافت الکترونیکی ابلاغیه‌ها در سامانه ثنا، روند مشاهده آن‌ها را بسیار سریع‌تر کرده است و افراد به‌سادگی و با استفاده از اینترنت می‌توانند ابلاغیه الکترونیکی ثنا را مشاهده کنند.",
    },
    {
      question: "روند ثبت‌نام در سامانه ثنا",
      answer:
        "برای ثبت‌نام در این سامانه باید فرایندی را طی کنید تا یک پنل کاربری در ثنا داشته باشید. فقط کافی است در این سامانه ثبت‌نام کنید؛ قوه قضاییه همه ابلاغیه‌ها را به پنل کاربری شما در سامانه ثنا اضافه می‌کند و می‌توانید با مراجعه به پنل کاربری خود، این ابلاغیه‌ها را با چند کلیک مشاهده کنید.",
    },
    {
      question: "ارتباط مستقیم با قوه قضاییه",
      answer:
        "آی‌تی‌ساز به‌عنوان کارگزار خدمات الکترونیک قوه قضاییه و با مجوز مرکز آمار و فناوری قوه قضاییه، ارتباط مستقیم با قوه قضاییه را دارا است. این ارتباط موجب سهولت ارائه خدمات آنلاین قضایی به ایرانیان متقاضی خارج از کشور شده است.",
    },
    {
      question: "خدمات VIP به ایرانیان خارج از کشور",
      answer:
        "به‌منظور سهولت و افزایش سرعت دریافت خدمات، اپراتور آی‌تی‌ساز امکان ارائه خدمات VIP را فراهم کرده است. شما می‌توانید با برقراری ارتباط با پشتیبانی از این خدمات بهره‌مند شوید.",
    },
  ],
};

export const faqGroups: FaqGroup[] = [
  {
    id: "general",
    label: "سوالات عمومی",
    items: [
      {
        question: "آیا همراه هوشمند برای ایرانیان خارج از کشور است؟",
        answer:
          "بله. همراه هوشمند با تمرکز بر نیازهای ایرانیان مقیم خارج از کشور طراحی شده است تا دسترسی به مجموعه‌ای از خدمات قضایی، حقوقی، اداری و ترجمه را از راه دور ساده‌تر کند.",
      },
      {
        question: "آیا برای دریافت خدمات باید به ایران سفر کنم؟",
        answer:
          "در بسیاری از خدمات، امکان ثبت درخواست و انجام بخش قابل توجهی از فرآیند به‌صورت غیرحضوری وجود دارد و هدف سامانه نیز کاهش نیاز به سفر و مراجعه حضوری به ایران است. با این حال، شرایط هر خدمت متفاوت است و ممکن است برخی مراحل خاص، بسته به نوع پرونده یا الزامات قانونی، نیازمند اقدام جداگانه باشد.",
      },
      {
        question: "آیا برای استفاده از خدمات به شماره موبایل ایران نیاز دارم؟",
        answer:
          "برای انجام برخی از خدمات، شماره موبایل ایران به نام متقاضی موردنیاز است. اگر شماره همراه ایرانی به نام خود ندارید، همراه هوشمند می‌تواند شماره همراه موردنیاز را برای شما فراهم کند تا امکان ثبت، ادامه فرایند و پیگیری درخواست وجود داشته باشد. همچنین هنگام ثبت درخواست، اطلاعات تماس متقاضی دریافت می‌شود تا ارتباط و پیگیری مراحل خدمت به‌سادگی انجام شود.",
      },
      {
        question: "چطور درخواست خود را ثبت کنم؟",
        answer:
          "ابتدا خدمت موردنظر خود را انتخاب کنید، سپس اطلاعات خواسته‌شده را در فرم مربوط به همان خدمت وارد کنید. پس از ثبت درخواست، مراحل بررسی و انجام خدمت پیگیری خواهد شد.",
      },
      {
        question: "آیا می‌توانم وضعیت درخواست خود را پیگیری کنم؟",
        answer:
          "بله. اطلاعات تماس شما هنگام ثبت درخواست دریافت می‌شود تا امکان اطلاع‌رسانی و پیگیری روند انجام خدمت فراهم باشد.",
      },
    ],
  },
  {
    id: "sana",
    label: "ثنا",
    items: [
      {
        question: "ثنا چیست و چرا برای ایرانیان خارج از کشور اهمیت دارد؟",
        answer:
          "ثنا سامانه ثبت‌نام الکترونیکی قوه قضاییه است و یکی از مهم‌ترین مسیرهای دسترسی به خدمات قضایی الکترونیکی محسوب می‌شود. افرادی که در ایران یا خارج از کشور پرونده و امور قضایی دارند، می‌توانند از حساب ثنا برای دریافت خدماتی مانند مشاهده ابلاغیه‌های قضایی استفاده کنند.",
      },
      {
        question: "آیا ایرانیان خارج از کشور می‌توانند در ثنا ثبت‌نام کنند؟",
        answer:
          "بله. امکان ثبت درخواست ثبت‌نام و احراز هویت ثنا برای ایرانیان خارج از کشور فراهم شده است.",
      },
      {
        question: "برای ثبت‌نام ثنا از خارج کشور چه مدارکی لازم است؟",
        answer:
          "اطلاعات هویتی متقاضی و مدارک مورد نیاز خدمت باید مطابق اطلاعات رسمی فرد ارائه شود. کارت ملی و اطلاعات صحیح هویتی از مهم‌ترین موارد مورد نیاز برای شروع فرآیند هستند.",
      },
      {
        question: "آیا برای ثبت‌نام ثنا باید در ایران حضور داشته باشم؟",
        answer:
          "خیر. خدمات مربوط به ثبت‌نام و احراز هویت ثنا برای ایرانیان خارج از کشور به‌صورت آنلاین ارائه می‌شود و برای شروع فرآیند، الزام به سفر به ایران وجود ندارد.",
      },
      {
        question: "اگر به شماره همراه دسترسی نداشته باشیم، چطور ابلاغیه‌ها را دریافت کنیم؟",
        answer: "پیام‌ها و ابلاغیه‌ها از طریق ایمیل به شما اطلاع‌رسانی می‌شوند.",
      },
      {
        question: "بعد از فعال شدن ثنا چه خدماتی در اختیار من قرار می‌گیرد؟",
        answer:
          "پس از فعال شدن حساب، می‌توانید از خدمات الکترونیک قضایی مرتبط استفاده کنید؛ از جمله مشاهده ابلاغیه‌های قضایی و استفاده از برخی خدمات قضایی آنلاین.",
      },
    ],
  },
  {
    id: "notices",
    label: "ابلاغیه قضایی",
    items: [
      {
        question: "چطور از خارج کشور ابلاغیه قضایی خود را ببینم؟",
        answer:
          "پس از داشتن حساب فعال ثنا، ابلاغیه‌های الکترونیکی قضایی در حساب کاربری شما قرار می‌گیرند و می‌توانید آن‌ها را مشاهده و بررسی کنید.",
      },
      {
        question: "اگر ابلاغیه جدید داشته باشم، باید حتماً آن را بررسی کنم؟",
        answer:
          "بله. ابلاغیه‌های قضایی ممکن است شامل زمان جلسه، رأی، اخطار یا مهلت قانونی باشند. به همین دلیل بهتر است ابلاغیه‌های جدید را در سریع‌ترین زمان ممکن بررسی کنید.",
      },
      {
        question: "آیا پیامک ابلاغیه قضایی کافی است؟",
        answer:
          "خیر. پیامک صرفاً می‌تواند اطلاع‌رسانی اولیه درباره وجود ابلاغیه باشد. برای اطلاع از محتوای دقیق و جزئیات موضوع، باید ابلاغیه را از مسیر رسمی مشاهده کنید.",
      },
      {
        question: "اگر متن ابلاغیه را متوجه نشوم چه کنم؟",
        answer:
          "در موارد مهم، به‌خصوص زمانی که ابلاغیه دارای مهلت قانونی یا مربوط به پرونده قضایی باشد، بهتر است متن آن را با یک وکیل یا مشاور حقوقی بررسی کنید.",
      },
    ],
  },
  {
    id: "criminal-record",
    label: "گواهی عدم سوءپیشینه",
    items: [
      {
        question: "آیا می‌توانم از خارج کشور گواهی عدم سوءپیشینه دریافت کنم؟",
        answer:
          "بله. ایرانیان خارج از کشور می‌توانند با توجه به شرایط خود از مسیرهای الکترونیکی و کنسولی برای دریافت گواهی عدم سوءپیشینه اقدام کنند.",
      },
      {
        question: "آیا برای دریافت گواهی عدم سوءپیشینه باید ثنا داشته باشم؟",
        answer:
          "برای استفاده از مسیر الکترونیکی قضایی، داشتن حساب فعال ثنا اهمیت دارد. اگر هنوز حساب ثنا ندارید، می‌توانید ابتدا برای ثبت‌نام و احراز هویت ثنا اقدام کنید.",
      },
      {
        question: "آیا گواهی عدم سوءپیشینه به زبان انگلیسی صادر می‌شود؟",
        answer:
          "گواهی صادرشده از مسیر قضایی معمولاً فارسی است. در صورتی که کشور مقصد نسخه ترجمه‌شده بخواهد، می‌توان برای ترجمه رسمی آن اقدام کرد.",
      },
      {
        question: "آیا ترجمه گواهی سوءپیشینه کافی است؟",
        answer:
          "این موضوع به کشور و مرجع دریافت‌کننده مدارک بستگی دارد. در برخی پرونده‌ها ممکن است علاوه بر ترجمه رسمی، تأییدات بیشتری نیز لازم باشد.",
      },
      {
        question: "گواهی عدم سوءپیشینه چقدر اعتبار دارد؟",
        answer: "اصل گواهی عدم سوءپیشینه ۶ ماه اعتبار دارد.",
      },
    ],
  },
  {
    id: "exit-ban",
    label: "ممنوع‌الخروجی",
    items: [
      {
        question: "آیا می‌توانم از خارج کشور وضعیت ممنوع‌الخروجی خود را استعلام کنم؟",
        answer:
          "بله. امکان ثبت درخواست برای دریافت گواهی عدم ممنوع‌الخروجی از طریق خدمات ارائه‌شده به ایرانیان خارج از کشور وجود دارد.",
      },
      {
        question: "چرا بهتر است قبل از سفر وضعیت ممنوع‌الخروجی را بررسی کنم؟",
        answer:
          "اگر فرد دارای محدودیت قانونی برای خروج از کشور باشد، این موضوع ممکن است برنامه سفر او را تحت تأثیر قرار دهد. بنابراین در صورت وجود سابقه پرونده یا مسائل حقوقی، بررسی وضعیت پیش از سفر می‌تواند از بروز مشکل جلوگیری کند.",
      },
      {
        question: "اگر ممنوع‌الخروج باشم، آیا گرفتن گواهی مشکل را برطرف می‌کند؟",
        answer:
          "خیر. گواهی صرفاً وضعیت فرد را مشخص می‌کند. رفع ممنوع‌الخروجی نیازمند پیگیری علت و طی کردن فرآیند قانونی مربوط به آن است.",
      },
    ],
  },
  {
    id: "legal-consultation",
    label: "مشاوره حقوقی و انتخاب وکیل",
    items: [
      {
        question: "آیا از خارج کشور می‌توانم با وکیل دادگستری در ایران مشورت کنم؟",
        answer: "بله. امکان دریافت مشاوره حقوقی آنلاین برای ایرانیان خارج از کشور فراهم شده است.",
      },
      {
        question: "برای چه موضوعاتی می‌توانم مشاوره حقوقی بگیرم؟",
        answer:
          "موضوعات مختلفی مانند پرونده‌های حقوقی و کیفری، مسائل ملکی، ارث، طلاق، مهریه، نفقه، چک، قراردادها، امور تجاری و سایر مسائل مرتبط با حقوق ایران می‌توانند موضوع مشاوره باشند.",
      },
      {
        question: "آیا مشاوره حقوقی به معنی گرفتن وکالت است؟",
        answer:
          "خیر. مشاوره و وکالت دو خدمت متفاوت هستند. مشاوره برای بررسی موضوع و انتخاب مسیر مناسب انجام می‌شود، در حالی که وکالت به معنای اختیار قانونی برای پیگیری امور از طرف موکل است.",
      },
      {
        question: "آیا می‌توانم از خارج کشور برای پرونده‌ام وکیل در ایران انتخاب کنم؟",
        answer:
          "بله. در صورت نیاز می‌توانید برای انتخاب وکیل دادگستری در ایران اقدام کنید تا امور مربوط به پرونده شما در چارچوب اختیارات قانونی پیگیری شود.",
      },
      {
        question: "قبل از انتخاب وکیل چه چیزهایی را باید بررسی کنم؟",
        answer:
          "بهتر است تخصص وکیل، تجربه او در پرونده‌های مشابه، حدود خدمات، نحوه ارتباط و شرایط وکالت را بررسی کنید.",
      },
      {
        question: "آیا برای انتخاب وکیل باید به ایران سفر کنم؟",
        answer:
          "برای شروع فرآیند و دریافت مشاوره لزوماً نیازی به سفر به ایران نیست. نحوه اعطای وکالت و مراحل بعدی با توجه به نوع پرونده و شرایط قانونی مشخص می‌شود.",
      },
    ],
  },
  {
    id: "official-translation",
    label: "ترجمه رسمی مدارک",
    items: [
      {
        question: "چه مدارکی را می‌توان به‌صورت رسمی ترجمه کرد؟",
        answer:
          "بسته به نیاز شما، مدارکی مانند شناسنامه، کارت ملی، سند ازدواج، سند طلاق، گواهی عدم سوءپیشینه، مدارک تحصیلی، ریزنمرات، اسناد ملکی، وکالت‌نامه و سایر اسناد رسمی می‌توانند موضوع ترجمه رسمی باشند.",
      },
      {
        question: "تفاوت ترجمه رسمی و ترجمه عادی چیست؟",
        answer:
          "ترجمه رسمی توسط مترجم رسمی انجام می‌شود و برای ارائه به مراجع رسمی کاربرد دارد. ترجمه عادی الزاماً چنین اعتبار و کاربردی ندارد.",
      },
      {
        question: "آیا ترجمه رسمی همیشه نیاز به تأیید دادگستری و وزارت امور خارجه دارد؟",
        answer: "خیر. نیاز به تأییدات بیشتر به نوع مدرک و دستورالعمل مرجع مقصد بستگی دارد.",
      },
      {
        question: "آیا می‌توان مدارک را به زبان کشور مقصد ترجمه کرد؟",
        answer:
          "بله، در صورتی که زبان موردنظر مورد قبول مرجع مقصد باشد و امکان انجام ترجمه رسمی آن زبان وجود داشته باشد.",
      },
      {
        question: "آیا برای ترجمه مدارک باید به ایران سفر کنم؟",
        answer:
          "برای ایرانیان خارج از کشور امکان ثبت درخواست ترجمه و پیگیری فرآیند از طریق خدمات بین‌الملل فراهم شده است و هدف این خدمت کاهش نیاز به حضور در ایران است.",
      },
    ],
  },
  {
    id: "transaction-eligibility",
    label: "استعلام و اعتبارسنجی معاملاتی",
    items: [
      {
        question: "اعتبارسنجی معاملاتی افراد چیست؟",
        answer:
          "این خدمت برای بررسی وضعیت معاملاتی و برخی محدودیت‌های قانونی مرتبط با شخص موردنظر استفاده می‌شود و می‌تواند یکی از بررسی‌های اولیه پیش از انجام معامله باشد.",
      },
      {
        question: "چرا قبل از معامله باید وضعیت طرف مقابل را بررسی کنیم؟",
        answer:
          "در معاملات مهم، به‌خصوص خرید و فروش ملک یا خودرو، شناخت وضعیت قانونی طرف مقابل می‌تواند به کاهش ریسک معامله کمک کند.",
      },
      {
        question: "آیا استعلام اعتبار معاملاتی تضمین می‌کند معامله بدون مشکل خواهد بود؟",
        answer:
          "خیر. این استعلام تنها یکی از مراحل بررسی معامله است و جایگزین بررسی سند، مالکیت، قرارداد، بدهی‌ها و سایر مسائل حقوقی نمی‌شود.",
      },
      {
        question: "آیا می‌توان برای معامله ملک از این خدمت استفاده کرد؟",
        answer:
          "بله. بررسی وضعیت طرف معامله می‌تواند یکی از اقدامات احتیاطی قبل از معامله ملک باشد؛ البته خود ملک نیز باید از نظر سند و وضعیت حقوقی به‌طور جداگانه بررسی شود.",
      },
    ],
  },
  {
    id: "bounced-cheques",
    label: "چک و چک برگشتی",
    items: [
      {
        question: "آیا می‌توان سابقه مرتبط با چک را استعلام کرد؟",
        answer:
          "بله. امکان ثبت درخواست برای استعلام سابقه طرح دعاوی مرتبط با چک در مجموعه خدمات قضایی ارائه‌شده به ایرانیان خارج از کشور وجود دارد.",
      },
      {
        question: "آیا استعلام چک برگشتی به معنی تضمین وصول چک است؟",
        answer:
          "خیر. هیچ استعلامی پرداخت آینده چک را تضمین نمی‌کند. نتیجه استعلام تنها اطلاعات موجود را برای ارزیابی بهتر در اختیار شما قرار می‌دهد.",
      },
      {
        question: "قبل از قبول چک چه مواردی را بررسی کنیم؟",
        answer:
          "بهتر است مشخصات صادرکننده، اطلاعات چک، مبلغ، تاریخ سررسید، سوابق مرتبط و شرایط قرارداد را بررسی کنید.",
      },
      {
        question: "اگر طرف معامله سابقه چک برگشتی داشته باشد، معامله را انجام ندهیم؟",
        answer:
          "وجود سابقه چک برگشتی به‌تنهایی به معنی غیرممکن بودن معامله نیست، اما می‌تواند هشداری برای بررسی بیشتر و دریافت تضمین‌های مناسب‌تر باشد.",
      },
      {
        question: "اگر چک من برگشت خورد چه اقدامی انجام دهم؟",
        answer:
          "بهتر است در سریع‌ترین زمان وضعیت چک را بررسی کرده و با توجه به شرایط آن، از مشاور حقوقی یا وکیل درباره مسیر قانونی مناسب کمک بگیرید.",
      },
    ],
  },
  {
    id: "payments",
    label: "پرداخت قبوض و هزینه‌ها",
    items: [
      {
        question: "آیا می‌توانم از خارج کشور قبوض ایران را پرداخت کنم؟",
        answer:
          "بله. خدمات پرداخت برای مواردی مانند قبوض قوه قضاییه، برخی هزینه‌های خودرو، آب، برق، گاز، تلفن و عوارض ملک در سامانه ارائه شده است.",
      },
      {
        question: "چه اطلاعاتی برای پرداخت قبض لازم است؟",
        answer:
          "بسته به نوع قبض، ممکن است شناسه قبض، شناسه پرداخت، کد شناسایی ملک، پلاک یا VIN خودرو و سایر اطلاعات مربوط مورد نیاز باشد.",
      },
      {
        question: "آیا می‌توان هزینه‌های قضایی را از خارج کشور پرداخت کرد؟",
        answer:
          "برای برخی خدمات قضایی امکان پرداخت هزینه از خارج کشور فراهم شده است و سامانه آی‌تی ساز امکان پرداخت ارزی برخی خدمات را نیز معرفی کرده است.",
      },
      {
        question: "آیا می‌توان خلافی و عوارض خودرو را از خارج کشور پرداخت کرد؟",
        answer:
          "بله، این موارد در مجموعه خدمات پرداخت سامانه قرار دارند و می‌توانید درخواست مربوط به آن‌ها را ثبت کنید.",
      },
    ],
  },
  {
    id: "security",
    label: "امنیت و اطلاعات کاربران",
    items: [
      {
        question: "آیا اطلاعاتی که هنگام ثبت درخواست وارد می‌کنم محرمانه است؟",
        answer:
          "اطلاعات ثبت‌شده برای انجام و پیگیری خدمت موردنظر استفاده می‌شود و به همین دلیل باید اطلاعات را به‌صورت صحیح و مطابق مدارک رسمی خود وارد کنید.",
      },
      {
        question: "آیا باید اطلاعات هویتی خود را دقیق وارد کنم؟",
        answer:
          "بله. اطلاعاتی مانند نام، کد ملی، تاریخ تولد و سایر اطلاعات شناسایی باید دقیق و مطابق مدارک رسمی باشند. هرگونه مغایرت ممکن است باعث ایجاد مشکل در روند انجام خدمت شود.",
      },
      {
        question: "آیا می‌توان برای یک شخص دیگر نیز درخواست ثبت کرد؟",
        answer:
          "بسته به نوع خدمت و شرایط آن، ممکن است امکان ثبت درخواست از طرف شخص دیگر وجود داشته باشد. شرایط هر خدمت هنگام ثبت درخواست مشخص می‌شود.",
      },
    ],
  },
];

export interface ContactSign {
  title: string;
  description: string;
  icon: string;
}

export const contactSigns: ContactSign[] = [
  {
    title: "موضوع را در یک جمله مشخص کنید",
    description: "مشخص کنید برای انتخاب خدمت، ثبت درخواست یا پیگیری یک پرونده پیام می‌دهید.",
    icon: "message-circle",
  },
  {
    title: "کشور و منطقه زمانی را بنویسید",
    description: "این اطلاعات به هماهنگی بهتر پاسخ‌گویی بین‌المللی کمک می‌کند.",
    icon: "map-pin",
  },
  {
    title: "شماره درخواست را آماده کنید",
    description:
      "برای پیگیری سریع‌تر، شماره درخواست را همراه داشته باشید؛ مدارک حساس را فقط در درگاه رسمی وارد کنید.",
    icon: "hash",
  },
];

export interface ContactChannel {
  label: string;
  value: string;
  href: string;
  actionLabel: string;
  icon: string;
}

export const contactChannels: ContactChannel[] = [
  {
    label: "واتساپ",
    value: "+۹۸ ۹۰۵ ۰۷۰ ۵۱۵۶",
    href: "https://api.whatsapp.com/send/?phone=989050705156&text=%D8%B3%D9%84%D8%A7%D9%85%D8%8C+%D8%A8%D8%B1%D8%A7%DB%8C+%D8%AF%D8%B1%DB%8C%D8%A7%D9%81%D8%AA+%D8%B1%D8%A7%D9%87%D9%86%D9%85%D8%A7%DB%8C%DB%8C+%D8%AF%D8%B1%D8%A8%D8%A7%D8%B1%D9%87+%D8%AE%D8%AF%D9%85%D8%A7%D8%AA+%D9%87%D9%85%D8%B1%D8%A7%D9%87+%D9%87%D9%88%D8%B4%D9%85%D9%86%D8%AF+%D9%BE%DB%8C%D8%A7%D9%85+%D9%85%DB%8C%E2%80%8C%D8%AF%D9%87%D9%85.&type=phone_number&app_absent=0",
    actionLabel: "ورود به واتساپ",
    icon: "phone-call",
  },
  {
    label: "تلگرام",
    value: "@Sanasupport",
    href: "https://t.me/Sanasupport",
    actionLabel: "ورود به تلگرام",
    icon: "send",
  },
  {
    label: "پست الکترونیک",
    value: "international.sana.itsaaz@gmail.com",
    href: "mailto:international.sana.itsaaz@gmail.com",
    actionLabel: "ارسال ایمیل",
    icon: "mail",
  },
];

export interface CredentialItem {
  icon: string;
  title: string;
  description: string;
}

export const credentials: CredentialItem[] = [
  {
    icon: "shield-check",
    title: "ارائه‌دهنده رسمی",
    description: "خدمات حاکمیتی، دولتی و قضایی",
  },
  {
    icon: "badge-check",
    title: "مجوز قوه قضائیه",
    description: "مرکز آمار و فناوری اطلاعات",
  },
  {
    icon: "graduation-cap",
    title: "زیست‌بوم نوآوری شریف",
    description: "مستقر در اکوسیستم دانشگاه شریف",
  },
  {
    icon: "map-pin",
    title: "پوشش سراسری کشور",
    description: "بزرگ‌ترین شبکه خدمات حضوری",
  },
];

export interface FeaturePageItem {
  icon: string;
  title: string;
  description: string;
}

export const aboutStory: FeaturePageItem[] = [
  {
    icon: "map-pin",
    title: "چالش واقعی",
    description:
      "مشکل اصلی همیشه خود خدمت نیست؛ در بسیاری از موارد، دسترسی به خدمت، انجام درست مراحل و پیگیری آن از خارج کشور چالش اصلی است. همراه هوشمند با هدف حل همین مسئله شکل گرفته است.",
  },
  {
    icon: "building",
    title: "پشتوانه اجرایی",
    description:
      "همراه هوشمند توسط شرکت «آی‌تی‌ساز» قدرت گرفته است؛ شرکتی که با تکیه بر دانش فنی، تجربه اجرایی و زیرساخت‌های فناوری خود، زمینه توسعه و ارائه خدمات این سامانه را فراهم کرده است.",
  },
  {
    icon: "road",
    title: "چیزی که می‌خواهیم تغییر دهیم",
    description:
      "ما تلاش می‌کنیم مسیر دسترسی ایرانیان خارج از کشور به خدمات مورد نیازشان در ایران را ساده‌تر، شفاف‌تر و قابل پیگیری کنیم؛ تا انجام امور ضروری، کمتر به فاصله جغرافیایی وابسته باشد.",
  },
];

export const aboutApproach: FeaturePageItem[] = [
  {
    icon: "users",
    title: "چرا همراه هوشمند؟",
    description:
      "ما باور داریم خدماتی که برای ایرانیان خارج از کشور ارائه می‌شوند، باید با شرایط واقعی زندگی آن‌ها طراحی شده باشند.",
  },
  {
    icon: "layers",
    title: "یک سامانه برای انجام ساده‌تر امور",
    description:
      "ما نمی‌خواهیم همراه هوشمند فقط محلی برای ثبت یک فرم درخواست باشد. تلاش ما این است که کاربر بتواند قبل از ثبت درخواست، اطلاعات کافی درباره خدمت موردنظر خود داشته باشد.",
  },
  {
    icon: "passport",
    title: "تمرکز ما روی ایرانیان خارج از کشور است",
    description:
      "نیازهای یک ایرانی مقیم خارج از کشور با فردی که در ایران زندگی می‌کند یکسان نیست. ممکن است یک کار ساده در ایران، برای فردی که در اروپا، آمریکا، کانادا، استرالیا یا هر کشور دیگری زندگی می‌کند، به یک فرآیند پیچیده تبدیل شود.",
  },
];

export const aboutPrinciples: FeaturePageItem[] = [
  {
    icon: "check-circle",
    title: "سادگی",
    description:
      "فرآیند دریافت خدمت باید تا حد امکان ساده و قابل فهم باشد؛ حتی برای فردی که با ساختار اداری ایران آشنایی کاملی ندارد.",
  },
  {
    icon: "eye",
    title: "شفافیت",
    description:
      "کاربر باید بداند چه خدمتی دریافت می‌کند، چه اطلاعاتی لازم است و درخواست او در چه مسیری قرار دارد.",
  },
  {
    icon: "message-circle",
    title: "همراهی",
    description:
      "ثبت درخواست پایان ارتباط ما با شما نیست. پیگیری و ارتباط با متقاضی، بخش مهمی از تجربه دریافت خدمت است.",
  },
];

export interface PressSource {
  topic: string;
  source: string;
  title: string;
  href: string;
}

export const pressSources: PressSource[] = [
  {
    topic: "معرفی خدمات",
    source: "وزارت امور خارجه",
    title: "منبع رسمی در وبگاه اتاوا ـ وزارت امور خارجه",
    href: "https://ottawa.mfa.ir/portal/viewPage/16427",
  },
  {
    topic: "خدمات قضایی",
    source: "عمان چنس",
    title: "دسترسی ۲۴ ساعته ایرانیان خارج از کشور به خدمات الکترونیک قضایی",
    href: "https://omanchance.com/1402/10/26/دسترسی-۲۴-ساعته-ایرانیان-خارج-از-کشور/",
  },
  {
    topic: "امور ایرانیان",
    source: "وزارت امور خارجه",
    title: "منبع رسمی در وبگاه امور ایرانیان ـ وزارت امور خارجه",
    href: "https://iranian.mfa.ir/portal/newsview/760380",
  },
  {
    topic: "دسترسی به خدمات",
    source: "وزارت امور خارجه",
    title: "دسترسی ۲۴ ساعته ایرانیان خارج از کشور به خدمات الکترونیک قضایی",
    href: "https://porsesh.mfa.ir/index.php?rp=/announcements/49/%D8%AF%D8%B3%D8%AA%D8%B1%D8%B3%DB%8C-%DB%B2%DB%B4-%D8%B3%D8%A7%D8%B9%D8%AA%D9%87-%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86-%D8%AE%D8%A7%D8%B1%D8%AC-%D8%A7%D8%B2-%DA%A9%D8%B4%D9%88%D8%B1-%D8%A8%D9%87-%D8%AE%D8%AF%D9%85%D8%A7%D8%AA-%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9-%D9%82%D8%B6%D8%A7%DB%8C%DB%8C.html",
  },
  {
    topic: "ثبت‌نام ثنا",
    source: "وزارت امور خارجه",
    title: "چگونه در خارج از کشور در سامانه ثنا ثبت‌نام کنیم؟",
    href: "https://porsesh.mfa.ir/index.php?rp=/knowledgebase/42/%DA%86%DA%AF%D9%88%D9%86%D9%87-%D9%85%DB%8C-%D8%AA%D9%88%D8%A7%D9%86%D9%85-%D8%AF%D8%B1-%D8%AE%D8%A7%D8%B1%D8%AC-%D8%A7%D8%B2-%DA%A9%D8%B4%D9%88%D8%B1-%D8%AF%D8%B1-%D8%B3%D8%A7%D9%85%D8%A7%D9%86%D9%87-%D8%AB%D9%86%D8%A7-%D8%AB%D8%A8%D8%AA-%D9%86%D8%A7%D9%85-%DA%A9%D9%86%D9%85-.html",
  },
  {
    topic: "خدمات آنلاین",
    source: "عصر ایران",
    title: "خبر خوب قوه قضاییه به ایرانیان خارج از کشور؛ تمامی خدمات الکترونیک قضایی آنلاین شد",
    href: "https://www.asriran.com/fa/news/930470/%D8%AE%D8%A8%D8%B1-%D8%AE%D9%88%D8%A8-%D9%82%D9%88%D9%87-%D9%82%D8%B6%D8%A7%DB%8C%DB%8C%D9%87-%D8%A8%D9%87-%D8%A7%DB%8C%D8%B1%D8%A7%D9%86%DB%8C%D8%A7%D9%86-%D8%AE%D8%A7%D8%B1%D8%AC-%D8%A7%D8%B2-%DA%A9%D8%B4%D9%88%D8%B1-%D8%AA%D9%85%D8%A7%D9%85%DB%8C-%D8%AE%D8%AF%D9%85%D8%A7%D8%AA-%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9-%D9%82%D8%B6%D8%A7%DB%8C%DB%8C-%D8%AF%D8%B1-%D8%AE%D8%A7%D8%B1%D8%AC-%D8%A7%D8%B2-%DA%A9%D8%B4%D9%88%D8%B1-%D8%A2%D9%86%D9%84%D8%A7%DB%8C%D9%86-%D8%B4%D8%AF",
  },
  {
    topic: "خدمات آنلاین",
    source: "فرارو",
    title: "تمامی خدمات الکترونیک قضایی در خارج از کشور آنلاین شد",
    href: "https://fararu.com/fa/news/695125/%D8%AA%D9%85%D8%A7%D9%85%DB%8C-%D8%AE%D8%AF%D9%85%D8%A7%D8%AA-%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9-%D9%82%D8%B6%D8%A7%DB%8C%DB%8C-%D8%AF%D8%B1-%D8%AE%D8%A7%D8%B1%D8%AC-%D8%A7%D8%B2-%DA%A9%D8%B4%D9%88%D8%B1-%D8%A2%D9%86%D9%84%D8%A7%DB%8C%D9%86-%D8%B4%D8%AF",
  },
];

export interface ArticleItem {
  slug: string;
  category: string;
  title: string;
  summary: string;
  readTime: string;
  date: string;
}

export const featuredArticle: ArticleItem = {
  slug: "sana-registration-abroad",
  category: "راهنمای ثنا",
  title: "ثبت‌نام ثنا برای ایرانیان خارج از کشور؛ راهنمای کامل احراز هویت و دریافت کد ثنا",
  summary:
    "راهنمای مدارک، ثبت درخواست، احراز هویت آنلاین و دسترسی به ابلاغیه‌های قضایی از خارج کشور.",
  readTime: "۱۰ دقیقه مطالعه",
  date: "۲۷ مرداد ۱۴۰۵",
};

export const archiveArticles: ArticleItem[] = [
  {
    slug: "check-bounced-cheques-and-legal-history",
    date: "۲ شهریور ۱۴۰۵",
    category: "چک و مطالبات",
    title: "استعلام چک برگشتی و سابقه دعاوی چک؛ راهنمای بررسی اعتبار چک قبل از معامله",
    summary:
      "راهنمای تفاوت استعلام وضعیت چک با سابقه دعاوی مرتبط، ارزیابی ریسک صادرکننده و بررسی‌های ضروری پیش از پذیرش چک در معامله.",
    readTime: "۱۴ دقیقه مطالعه",
  },
  {
    slug: "sana-access-electronic-signature-abroad",
    date: "۲ شهریور ۱۴۰۵",
    category: "راهنمای ثنا",
    title: "دسترسی به سامانه ثنا و ثبت امضای الکترونیک قضایی برای ایرانیان خارج از کشور",
    summary:
      "راهنمای دسترسی به حساب ثنا، ثبت امضای الکترونیک قضایی و استفاده از خدمات قضایی آنلاین بدون نیاز به شماره همراه داخلی.",
    readTime: "۱۰ دقیقه مطالعه",
  },
  {
    slug: "choose-lawyer-iran-from-abroad",
    date: "۲ شهریور ۱۴۰۵",
    category: "انتخاب وکیل",
    title: "انتخاب وکیل در ایران برای ایرانیان خارج از کشور؛ راهنمای کامل",
    summary:
      "راهنمای انتخاب وکیل متناسب با موضوع پرونده، آماده‌سازی مدارک و اعطای وکالت برای پیگیری امور حقوقی در ایران از خارج کشور.",
    readTime: "۱۲ دقیقه مطالعه",
  },
  {
    slug: "exit-ban-certificate-abroad",
    date: "۲ شهریور ۱۴۰۵",
    category: "گواهی‌ها",
    title: "گواهی عدم ممنوع‌الخروجی برای ایرانیان خارج از کشور؛ نحوه استعلام و دریافت",
    summary:
      "راهنمای استعلام وضعیت ممنوع‌الخروجی، دریافت گواهی رسمی و نکات مهم پیش از سفر به ایران برای ایرانیان خارج از کشور.",
    readTime: "۹ دقیقه مطالعه",
  },
  {
    slug: "pay-iranian-bills-from-abroad",
    date: "۲ شهریور ۱۴۰۵",
    category: "پرداخت از خارج کشور",
    title: "پرداخت قبوض قوه قضاییه و دولتی از خارج کشور؛ راهنمای کامل",
    summary:
      "راهنمای ثبت درخواست پرداخت هزینه‌های قضایی، خودرو، آب، برق، گاز، تلفن و عوارض ملک برای ایرانیان خارج از کشور.",
    readTime: "۱۰ دقیقه مطالعه",
  },
  {
    slug: "sana-registration-abroad",
    date: "۲۷ مرداد ۱۴۰۵",
    category: "راهنمای ثنا",
    title: "ثبت‌نام ثنا برای ایرانیان خارج از کشور؛ راهنمای کامل احراز هویت و دریافت کد ثنا",
    summary:
      "راهنمای مدارک، ثبت درخواست، احراز هویت آنلاین و دسترسی به ابلاغیه‌های قضایی از خارج کشور.",
    readTime: "۱۰ دقیقه مطالعه",
  },
  {
    slug: "view-electronic-notices",
    date: "۲ شهریور ۱۴۰۵",
    category: "ابلاغیه الکترونیکی",
    title: "مشاهده ابلاغیه قضایی از خارج کشور؛ راهنمای کامل دریافت و پیگیری ابلاغیه ثنا",
    summary:
      "راهنمای کامل مشاهده، دریافت و پیگیری ابلاغیه‌های الکترونیکی ثنا، مهلت‌های قانونی و نکات امنیتی برای ایرانیان خارج از کشور.",
    readTime: "۱۳ دقیقه مطالعه",
  },
  {
    slug: "criminal-record-certificate-abroad",
    date: "۱۲ مرداد ۱۴۰۵",
    category: "گواهی‌ها",
    title: "گواهی عدم سوءپیشینه برای ایرانیان خارج از کشور؛ راهنمای کامل دریافت و ترجمه",
    summary:
      "راهنمای دریافت گواهی عدم سوءپیشینه از طریق ثنا و میخک، مدارک لازم، ترجمه رسمی و اعتبار گواهی برای ایرانیان خارج از کشور.",
    readTime: "۶ دقیقه مطالعه",
  },
  {
    slug: "protect-judicial-account",
    date: "۴ مرداد ۱۴۰۵",
    category: "امنیت دیجیتال",
    title: "۵ اصل امنیتی برای محافظت از حساب قضایی شما",
    summary:
      "چگونه پیام‌های جعلی را تشخیص دهید و اطلاعات حساس پرونده را در سفر یا خارج از کشور امن نگه دارید.",
    readTime: "۴ دقیقه مطالعه",
  },
  {
    slug: "online-legal-consultation-iranians-abroad",
    date: "۲ شهریور ۱۴۰۵",
    category: "مشاوره حقوقی",
    title: "مشاوره حقوقی آنلاین برای ایرانیان خارج از کشور؛ راهنمای دریافت مشاوره از وکیل دادگستری",
    summary:
      "راهنمای دریافت مشاوره حقوقی آنلاین، آماده‌سازی مدارک و انتخاب مسیر مناسب برای پیگیری امور حقوقی و قضایی در ایران.",
    readTime: "۱۲ دقیقه مطالعه",
  },
  {
    slug: "official-document-translation-iranians-abroad",
    date: "۲ شهریور ۱۴۰۵",
    category: "ترجمه رسمی",
    title: "ترجمه رسمی مدارک برای ایرانیان خارج از کشور؛ راهنمای کامل ترجمه و تأییدات",
    summary:
      "راهنمای ترجمه رسمی مدارک ایرانی، تأییدات دادگستری و وزارت امور خارجه و نکات مهم پیش از ارائه مدارک به مرجع مقصد.",
    readTime: "۱۴ دقیقه مطالعه",
  },
  {
    slug: "transaction-eligibility-check",
    date: "۲ شهریور ۱۴۰۵",
    category: "استعلام معاملاتی",
    title: "استعلام و اعتبارسنجی معاملاتی افراد؛ راهنمای کامل بررسی وضعیت طرف معامله",
    summary:
      "راهنمای بررسی وضعیت قانونی طرف معامله، ممنوع‌المعامله بودن و نکات مهم پیش از خرید ملک، خودرو یا انجام معاملات مالی.",
    readTime: "۱۴ دقیقه مطالعه",
  },
];
